import amplitude, { AmplitudeClient } from "amplitude-js";
import { Utils } from "./Utils";
import Logger from "js-logger";

const RESULT_EVENT_NAME = "Liveness detection - result";
const LIGHTING_SCORE_EVENT_NAME = "Liveness detection - lighting score";
const SESSION_START = "Liveness detection - start";
const MODEL_LOADED = "Liveness detection - model loaded";
const START_FACE_STATE = "Liveness detection - start face state";
const START_AREA_STATE = "Liveness detection - start area state";
const START_NOSE_STATE = "Liveness detection - start nose state";
const START_FACE_UP_STATE = "Liveness detection - start faceup state";
const START_RECORD_ERROR = "Liveness detection - start record error";
const UPLOAD_VIDEO_ERROR = "Liveness detection - upload video error";
const STOP_RECORD_ERROR = "Liveness detection - stop record error";
const RESET_RECORD_ERROR = "Liveness detection - reset record error";
const CAMERA_EVENT_NAME = "Liveness detection - camera";

export class EventLogger {
  static _singleton: EventLogger;
  static get singleton(): EventLogger {
    if (!EventLogger._singleton) {
      this._singleton = new EventLogger();
    }
    return this._singleton;
  }
  private ampInstance: AmplitudeClient;
  constructor() {
    this.ampInstance = amplitude.getInstance();
    this.ampInstance.init(Utils.getConfig().AMPLITUDE_API_KEY);
    const userId = Utils.getRemiUserId();
    if (userId) {
      this.ampInstance.setUserId(userId + "");
    }
  }
  sendResultSuccessEvent(hasVideoInputDevice: boolean) {
    this.sendEventLog(RESULT_EVENT_NAME, { isSuccessEvent: true, hasVideoInputDevice });
  }
  sendResultFailEvent(failCode: string | null) {
    this.sendEventLog(RESULT_EVENT_NAME, { isSuccessEvent: false, failCode });
  }
  sendLightingScoreWhenFail(score: { scoreOfAreaEdge: number; scoreOfCenter: number }) {
    this.sendEventLog(LIGHTING_SCORE_EVENT_NAME, score);
  }
  sendCameraSelectedEvent(sameWithExpectation: boolean, autoSelect: boolean, strategy: string) {
    this.sendEventLog(CAMERA_EVENT_NAME, { action: "selected", sameWithExpectation, autoSelect, strategy });
  }
  sendSessionStartEvent() {
    this.sendEventLog(SESSION_START);
  }
  sendModelLoadedEvent() {
    this.sendEventLog(MODEL_LOADED);
  }
  sendStartFaceStateEvent() {
    this.sendEventLog(START_FACE_STATE);
  }
  sendStartAreaStateEvent() {
    this.sendEventLog(START_AREA_STATE);
  }
  sendStartNoseStateEvent() {
    this.sendEventLog(START_NOSE_STATE);
  }
  sendStartFaceUpStateEvent() {
    this.sendEventLog(START_FACE_UP_STATE);
  }
  sendCameraRequestErrorEvent(error: string) {
    this.sendEventLog(CAMERA_EVENT_NAME, { action: "requestFail", error });
  }

  sendStartRecorderErrorEvent(error: string) {
    this.sendEventLog(START_RECORD_ERROR, { error: EventLogger.messageFromError(error) });
  }

  sendCannotStartCameraConfirm() {
    this.sendEventLog(CAMERA_EVENT_NAME, { action: "cannotStartCameraConfirm" });
  }

  sendUploadVideoErrorEvent(error: string) {
    this.sendEventLog(UPLOAD_VIDEO_ERROR, { error: EventLogger.messageFromError(error) });
  }

  sendStopRecorderErrorEvent(error: string) {
    this.sendEventLog(STOP_RECORD_ERROR, { error: EventLogger.messageFromError(error) });
  }

  sendResetRecorderErrorEvent(error: string) {
    this.sendEventLog(RESET_RECORD_ERROR, { error: EventLogger.messageFromError(error) });
  }

  static messageFromError(error: any): string {
    return error.message && error.name ? `${error.name}: ${error.message}` : error.toString();
  }

  private sendEventLog(eventName: string, params: any = null) {
    Logger.info(eventName, params);
    this.ampInstance.logEvent(eventName, params);
  }
}
